import React from "react";
import "../styles/About.css";
import binuImage from "../assets/images/binu-photo.png";

const features = [
  {
    title: "What makes me different?",
    text: "My work is more than just a job, it is a passion. <br/>Each time I take on a new project, I make sure it aligns with my core set of values so I know I can deliver great results.<br/>I'm always working on something. Most of the time, it's getting results for my clients.<br/> Human Beings are not machines, which are automated. Humans need to be Trained, Guided, Counselled and you can be moulded into the life that you want.",
  },
  {
    title: "About Me",
    text: 'Worked with <span style="font-weight:bold">Nestlé, India</span> and with <span style="font-weight:bold">Associated British Foods, U.K.</span> as Managing Director for all Countries in South and West Asia. <br /><span style="font-weight:bold">ICF Certified Life Coach (International Coaching Federation), EX-ALOYSIAN School Captain</span>.<br/>I\'m an expert in my field but I wouldn\'t be where I am without those who\'ve helped me along the way. <br/>That\'s why I love connecting with like-minded people and using my passion and skills to make a difference.',
  },
];

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <img src={binuImage} alt="Binu Varghese" className="about-img" />
        <h2>BINU VARGHESE</h2>
        <h3 className="about-text">
          Globally Experienced Corporate Leader, experienced with Nestlé, India
          and with Associated British Foods, London
        </h3>
        <h3 className="about-text">
          <strong>Trainer | Business Consultant</strong>
        </h3>

        <div className="about-features">
          {features.map((feature, idx) => (
            <div className="feature" key={idx}>
              <h4>{feature.title}</h4>
              <p dangerouslySetInnerHTML={{ __html: feature.text }} />
            </div>
          ))}
        </div>
        <h4 className="about-text about-quote">
          When you need fresh ideas and sound advice, turn to the expert with
          years of experience and a name you can trust. I'll be there for you
          every step of the way.
        </h4>
      </div>
    </section>
  );
};

export default About;
